mutation DocumentShareCreate($input: EntityDocumentShareCreateInput!) {
  entityDocumentShareCreate(input: $input) {
   threadMessageId
  }
}
